module.exports = __webpack_public_path__ + "img/05.f1f27434.png";